<template>
  <Modal
    @closeModal="closeModal"
    v-show="showModal"
    :isSaving="isLoading"
    title="Delete Confirmation"
    :okFunction="deleteContent"
  >
    <template v-slot:body>
      <div class="delete-description">Are you sure you want to delete selected templates?</div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import { apiDeleteTemplates } from '@/api/templates';

  export default {
    name: 'MultipleContentDeleteModal',

    components: { Modal },

    props: {
      templates: {
        type: Array,
      },
    },

    data() {
      return {
        showModal: false,
        isLoading: false,
      };
    },

    mounted() {
      this.showModal = true;
    },

    methods: {
      async deleteContent() {
        this.isLoading = true;

        try {
          await apiDeleteTemplates(this.templates.map((item) => item.template_id));
          this.$toasted.global.general_success({ message: 'Templates successfully deleted' });
          this.$emit('onDelete');
          this.closeModal();
        } catch (error) {
          this.$toasted.global.general_error({
            message: error.response?.data?.message || 'Failed to delete the items',
          });
        }
        this.isLoading = false;
      },

      closeModal() {
        this.showModal = false;
        this.$emit('onClose');
      },
    },
  };
</script>
